import { useParams, Link } from 'react-router-dom';
import { Col, Row, Divider, Carousel } from 'antd';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import DefaultLayout from '../components/DefaultLayout';
import Spinner from '../components/Spinner';
import { getAllCars } from '../redux/actions/carsActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import 'aos/dist/aos.css'; // You can also use <link> for styles


function CarDetails() {
    const { cars } = useSelector((state) => state.cars);
    const { loading } = useSelector((state) => state.alerts);
    const [car, setcar] = useState({});
    const dispatch = useDispatch();
    
    const { id } = useParams();

    useEffect(() => {
        if (cars.length == 0) {
            dispatch(getAllCars());
        } else {
            setcar(cars.find((o) => o._id === (id)));
        }
    }, [cars]);

    
    return (
        <DefaultLayout>
            {loading && <Spinner />}

            <h3 className='m-5'>Car Details - <span> {car.name} </span></h3>
            <Row
                justify="center"
                className="d-flex align-items-center"
                style={{ minHeight: '90vh' }} >

                <Col lg={10} sm={24} xs={24} className='p-3'>
                    <Carousel autoplay>
                        {car.images &&
                            car.images.map((item, i) => (
                                <img
                                    className="carimg2 bs1 w-100"
                                    key={i}
                                    src={item.url}
                                    alt={`${i} Slide`}
                                />
                            ))}
                    </Carousel>
                </Col>

                <Col lg={10} sm={24} xs={24} className="text-right">
                    <Divider dashed style={{ borderColor: '#000' }}>
                        <span><strong>Car Info</strong></span>
                    </Divider>
                    <div style={{ textAlign: 'right' }}>
                        <p>{car.name} </p>
                        <p>{car.rentPerHour} USD/- Per Rental hour</p>
                        <p>Fuel Type : {car.fuelType}</p>
                        <p>Max Persons : {car.capacity}</p>
                    </div>

                    <Divider dashed style={{ borderColor: '#000' }}>
                        <span><strong>See Booking Details</strong></span>
                    </Divider>
                    <button className="btn1 mt-3">
                        <Link className='book' to={`/booking/${car._id}`}>
                            Book Now<FontAwesomeIcon icon={faAngleRight} size="4x" className='m-0' style={{color: 'orangered'}}/>
                        </Link>
                    </button>
            
                </Col>
                <Col lg={10} sm={24} xs={24} className="text-right p-3 mt-5">
                    <div>
                        <button className="btn1" style={{backgroundColor: 'orangered', color: 'white'}}>
                            <Link className='book' to='/home'>
                                <FontAwesomeIcon icon={faAngleLeft} size="3x" className='m-0' style={{color: 'orangered'}}/>Back
                            </Link>
                        </button>
                    </div>
                </Col> 
            </Row>
        </DefaultLayout>
    );
}

export default CarDetails;
